






import { Component, Prop, Vue } from 'vue-property-decorator';
import CustomerService from '../../services/CustomerService';

@Component
export default class Home extends Vue {
    @Prop() private msg!: string;

    private async created() {
        await this.LoadScreens();
    }

    private async LoadScreens() {
        const user = this.$store.state.userInfo;

        const customerService: CustomerService = new CustomerService();
        const response = await customerService.GetScreensForUser(user.Id);

        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        }
    }
}
